import { createActivityModalExecutor } from '@organisms/actions/createActivityModalExecutor';
import { IDocumentsBatchEditingTableProps } from './IDocumentsBatchEditingTableProps';
import { DocumentsBatchEditingTableModal } from './DocumentsBatchEditingTableModal';

export const DocumentsBatchEditingTableExecutor = createActivityModalExecutor<IDocumentsBatchEditingTableProps>({
    modal: DocumentsBatchEditingTableModal,
    defaultModalSize: 'max',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        displayName: action.displayName,
        actionKey: action.key ?? '',
        docId: objId,
        title: action.options?.title ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
